var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.13 50.1L60.5 65H35.5V60H55.825C56.2772 59.9998 56.7209 59.8769 57.1088 59.6444C57.4967 59.412 57.8143 59.0787 58.0277 58.68C58.2411 58.2813 58.3425 57.8322 58.3209 57.3805C58.2992 56.9288 58.1555 56.4915 57.905 56.115L53.465 49.455C52.5526 48.0856 51.3163 46.9626 49.8658 46.1854C48.4154 45.4083 46.7955 45.0011 45.15 45H5.5C4.17392 45 2.90215 45.5268 1.96447 46.4645C1.02678 47.4021 0.5 48.6739 0.5 50V80C0.5 82.6522 1.55357 85.1957 3.42893 87.0711C5.3043 88.9464 7.84784 90 10.5 90H58.695C60.833 90.0005 62.9465 89.5439 64.8937 88.6609C66.8408 87.7778 68.5767 86.4887 69.985 84.88L100.5 50L93.24 47.58C90.8646 46.7892 88.3291 46.6055 85.8645 47.0456C83.4 47.4858 81.0848 48.5358 79.13 50.1ZM86.79 21.95C89.045 19.625 90.44 16.41 90.44 12.86C90.44 9.31 89.045 6.095 86.79 3.77C85.6491 2.58058 84.2799 1.63363 82.7643 0.985837C81.2488 0.338047 79.6182 0.00274285 77.97 3.22082e-07C77.97 3.22082e-07 71.75 -0.0150007 65.5 6.43C59.25 -0.0150007 53.03 3.22082e-07 53.03 3.22082e-07C51.3822 0.00209582 49.7518 0.336615 48.2363 0.983538C46.7208 1.63046 45.3514 2.57649 44.21 3.765C41.955 6.095 40.56 9.305 40.56 12.855C40.56 16.405 41.955 19.625 44.21 21.945L65.5 45L86.79 21.95Z",
    fill: "url(#paint0_linear_164_828)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_828",
    x1: 0.5,
    y1: 45,
    x2: 100.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandVector);
export default __webpack_public_path__ + "static/media/handVector.a5092558465fc020b08ba5511fdedd8d.svg";
export { ForwardRef as ReactComponent };